export default __webpack_public_path__ + "static/media/risenchrist.b8a2a318.jpg";